var render, staticRenderFns
import script from "./edit_log.vue?vue&type=script&lang=js&"
export * from "./edit_log.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4673aac')) {
      api.createRecord('d4673aac', component.options)
    } else {
      api.reload('d4673aac', component.options)
    }
    
  }
}
component.options.__file = "found/views/process/views/process_map/form/edit_log.vue"
export default component.exports